<template>
  <svg width="102" height="102" viewBox="0 0 102 102" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M47.9727 0H53.9447C54.2013 0.0567213 54.4552 0.145855 54.7118 0.164762C62.6825 0.726573 70.14 3.00083 76.9438 7.16309C90.1464 15.2364 98.2656 26.8832 101.123 42.1115C101.48 44.0185 101.658 45.9578 101.917 47.8809V53.842C101.836 54.5578 101.753 55.2709 101.674 55.9866C100.472 66.7529 96.4155 76.3037 89.1875 84.404C79.5908 95.1622 67.5092 100.956 53.0939 101.655C43.0434 102.142 33.5925 99.8052 24.9898 94.5652C11.7683 86.5108 3.64637 74.8505 0.794099 59.6114C0.437565 57.7045 0.259297 55.7652 0 53.8393C0 51.8514 0 49.8661 0 47.8782C0.0810305 47.1624 0.164762 46.4494 0.243091 45.7336C1.46125 34.7891 5.65052 25.1356 13.0432 16.9489C20.8897 8.25971 30.6133 2.83337 42.1818 0.791398C44.0995 0.453771 46.0415 0.259297 47.9727 0V0ZM50.9628 7.90047C27.2208 7.89507 7.95179 27.1074 7.91398 50.8304C7.87616 74.4994 27.1263 93.7495 50.9033 93.8198C74.6345 93.89 94.0277 74.5507 94.0007 50.8385C93.9737 27.1209 74.7128 7.90587 50.9628 7.89777V7.90047Z" fill="white" fill-opacity="0.2"/>
    <path d="M30.5 33L71 73.5M71 33L30.5 73.5" stroke="white" stroke-opacity="0.2" stroke-width="8" stroke-linecap="round"/>
  </svg>
</template>

<script>
  export default {
    name: 'OrderStatusCanceledIcon',
  }
</script>

<style scoped>

</style>
